export default __webpack_public_path__ + "static/media/plus_circle_blue.a45bb7ab.svg";